import type { DrupalIconTypes } from '../../../interfaces';
import { classes } from '../../utils/classes';

export const Icon = ({ type, className }: { type: DrupalIconTypes; className?: string }) => (
  <span
    className={classes(
      'size-2',
      type === 'ArrowLeft' ? 'icon-emp-arrow-large-left' : 'icon-emp-arrow-large-right',
      className,
    )}
  />
);
